import { useCallback, useEffect, useState } from "react";
import { frontendRuntimeIdentityHeaders } from "../../../runtime/runtimeIdentity";

export default function useFacilitatorProjects({ token, apiUrl }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!token) {
      setProjects([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError("");
      const response = await fetch(`${apiUrl}/projects/facilitator`, {
        headers: { Authorization: `Bearer ${token}`, ...frontendRuntimeIdentityHeaders() },
      });
      if (!response.ok) throw new Error("Could not load facilitator projects.");
      const payload = await response.json();
      setProjects(payload?.projects || []);
    } catch (requestError) {
      setError(requestError.message || "Could not load facilitator projects.");
    } finally {
      setLoading(false);
    }
  }, [apiUrl, token]);

  useEffect(() => { refresh(); }, [refresh]);
  return { projects, loading, error, refresh };
}
